__turbopack_context__.v({
  "carousel": "pqgQqG_carousel",
  "carousel-arrows": "pqgQqG_carousel-arrows",
  "carousel-graphics": "pqgQqG_carousel-graphics",
  "carousel-header": "pqgQqG_carousel-header",
  "carousel-inner": "pqgQqG_carousel-inner",
  "carousel-wrapper": "pqgQqG_carousel-wrapper",
});
